import {AiOutlineCheck, AiOutlineClose, AiOutlineWarning} from "react-icons/ai"
import { useEffect, useState, useMemo } from "react";
import { Button, Select } from "antd"
import { Tag } from 'antd';
import { Tooltip } from "react-tooltip";
import { AiFillFolderOpen } from "react-icons/ai"
import JustificationModalLatest from "../../../activeProjectPage/detailCurrentProject/justificationComponent/JustificationModalLatest";
import { Form } from "react-bootstrap";
import ExcelFilter from "../../../activeProjectPage/detailCurrentProject/components/ExcelFilter";
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient";

const CalibrationTableSpmo = ({
        calibratedUsers, 
        projectPhase,
        phaseOption,
        checkAll,
        setMultipleJustificationDataByCheckbox,
        checkBoxes,
        onChangeHandler,
        setUserApprove,
        setIsAcceptModal,
        handleShow,
        canSubmit,
        canCheckAll,
        updateTable,
        userNameOption,
        gradeOption,
        supervisorNameOption,
        divisionOption,
        projectID,
        calibratorID,
    }) => {

    const [filteredUser, setFilteredUser] = useState(calibratedUsers)

    const [previousRating, setPreviousRating] = useState("Y1")
    const [options, setOptions] = useState([{"label": "Y-1", "value":"Y1"},{"label": "Y-2", "value":"Y2"}])
    const [latestCalibration, setLatestCalibration] = useState(-2)
    const customOrder = {
        "A+": 6,
        "A": 5,
        "B+": 4,
        "B": 3,
        "C": 2,
        "D": 1,
        "":0,
    };

    const [sortScoreLatestMinusOne, setSortScoreLatestMinusOne] = useState("default")
    const [sortRatingLatestMinusOne, setSortRatingLatestMinusOne] = useState("default")
    const [sortScoreLatest, setSortScoreLatest] = useState("default")
    const [sortRatingLatest, setSortRatingLatest] = useState("default")
    const [sortActualScore, setSortActualScore] = useState("default")
    const [sortActualRating, setSortActualRating] = useState("default")

    const [spmoComment, setSpmoComment] = useState()
    const [detailActualScore, setDetailActualScore] = useState({
        PTTScore : 0,
        PATScore: 0,
        Score360: 0
    })
    
    // Justification Before
    // const [calibrationJustification, setCalibrationJustification] = useState()
    const [userJustification, setUserJustification] = useState()
    const [justificationModalUserID, setJustificationModalUserID] = useState()
    const [showJustification, setShowJustification] = useState(false)
    const handleCloseJustification = () => setShowJustification(false)
    const handleShowJustification = () => setShowJustification(true)

    // Additional Info Modal
    const [showAdditionalInfo, setShowAdditionalInfo] = useState(false)
    const [selectedAdditionalInfo, setSelectedAdditionalInfo] = useState(null)

    // Filter Rating
    const [filterRatingBefore, setFilterRatingBefore] = useState("None")
    const [filterRating, setFilterRating] = useState("None")
    const [filterActualRating, setFilterActualRating] = useState("None")
    const [filterUserName, setFilterUserName] = useState([])
    const [filterGrade, setFilterGrade] = useState([])
    const [filterSupervisorName, setSupervisorName] = useState([])
    const [filterDivision, setFilterDivision] = useState([])
    const [filterChangeScore, setFilterChangeScore] = useState('all')
    const [filterColumn, setFilterColumn] = useState(['Employee', 'Grade', 'Supervisor', 'Division', 'Prev. Rating', 
        'Actual', 'Calibration (Previous)', 'Calibration', 'Status', 'Justification'])

    // Filter Name & Grade
    const [sortName, setSortName] = useState("default")
    const [sortGrade, setSortGrade] = useState("default")

    // Check if any user has Waiting status to show/hide Action column
    const hasWaitingStatus = useMemo(() => {
        return filteredUser?.some(user => 
            user.CalibrationScores[user.CalibrationScores.length - 1].SpmoStatus === "Waiting"
        ) || false;
    }, [filteredUser]);

    // OPtion
    const changedScoreOption = [
        { 'label': 'All', 'value': 'all'},
        { 'label': 'CHANGED', 'value': 'changed'},
        { 'label': 'UNCHANGED', 'value': 'unchanged'},
        { 'label': '+1 Rating', 'value': 1},
        { 'label': '+2 Rating', 'value': 2},
        { 'label': '-1 Rating', 'value': -1},
        { 'label': '-2 Rating', 'value': -2},
    ]

    const columnOption = [
        { 'label': 'Employee', 'value': 'Employee'},
        { 'label': 'Grade', 'value': 'Grade'},
        { 'label': 'Supervisor', 'value': 'Supervisor'},
        { 'label': 'Division', 'value': 'Division'},
        { 'label': 'Prev. Rating', 'value': 'Prev. Rating'},
        { 'label': 'Actual', 'value': 'Actual'},
        { 'label': 'Calibration (Previous)', 'value': 'Calibration (Previous)'},
        { 'label': 'Calibration', 'value': 'Calibration'},
        { 'label': 'Status', 'value': 'Status'},
        { 'label': 'Justification', 'value': 'Justification'},
    ]
    let ratingData = [
        { 'label': 'A+', 'value': 'A+'},
        { 'label': 'A', 'value': 'A'},
        { 'label': 'B+', 'value': 'B+'},
        { 'label': 'B', 'value': 'B'},
        { 'label': 'C', 'value': 'C'},
        { 'label': 'D', 'value': 'D'}
    ]

    const handleShowAdditionalInfoModal = (user) => {
        if (user.AdditionalInfo) {
            setSelectedAdditionalInfo({
                name: user.Name,
                nik: user.Nik,
                position: user.Position,
                supervisor: user.SupervisorNames,
                info: user.AdditionalInfo
            });
            setShowAdditionalInfo(true);
        }
    }

    useEffect(() => {
        updateTable(
            calibratedUsers, 
            sortScoreLatest, 
            sortRatingLatest, 
            filterRating, 
            sortScoreLatestMinusOne, 
            sortRatingLatestMinusOne, 
            filterRatingBefore,
            sortName,
            customOrder,
            latestCalibration,
            setFilteredUser,
            sortGrade,
            filterUserName,
            filterGrade,
            filterSupervisorName,
            filterChangeScore,
            filterDivision,
            sortActualScore,
            sortActualRating,
            filterActualRating,
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        calibratedUsers, 
        sortScoreLatest, 
        sortRatingLatest, 
        sortScoreLatestMinusOne, 
        sortRatingLatestMinusOne, 
        latestCalibration, 
        sortName, 
        filterRating, 
        filterRatingBefore, 
        sortGrade,
        filterUserName,
        filterGrade,
        filterSupervisorName,
        filterChangeScore,
        filterDivision,
        sortActualScore,
        sortActualRating,
        filterActualRating,
    ])

    return(
        <div>
            {/* Filter Controls */}
            <div align="right" className="mb-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: "14px" }}>Filter Rating:</span>
                    <ExcelFilter
                        options={changedScoreOption}
                        selectedValues={filterChangeScore !== 'all' ? [filterChangeScore] : []}
                        onApply={(values) => {
                            setFilterChangeScore(values.length > 0 ? values[0] : 'all');
                        }}
                        onSort={(direction) => {
                            console.log('Sort filter rating:', direction);
                        }}
                        currentSortState="default"
                        placeholder="Filter Rating"
                        label="Filter Rating"
                        singleSelect={true}
                        showSort={false}
                    />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: "14px" }}>Manage Columns:</span>
                    <ExcelFilter
                        options={columnOption}
                        selectedValues={filterColumn}
                        onApply={(values) => {
                            setFilterColumn(values);
                        }}
                        onSort={(direction) => {
                            console.log('Sort columns:', direction);
                        }}
                        currentSortState="default"
                        placeholder="Manage Columns"
                        label="Manage Columns"
                        singleSelect={false}
                        showSort={false}
                    />
                </div>

                {/* Reset Filters Button */}
                <ActionButtonGradient
                    onClick={() => {
                        setFilterChangeScore('all');
                        setFilterUserName([]);
                        setFilterGrade([]);
                        setSupervisorName([]);
                        setFilterDivision([]);
                        setFilterRating('None');
                        setFilterRatingBefore('None');
                        setFilterActualRating('None');
                        setPreviousRating('Y1');
                        setSortName('default');
                        setSortGrade('default');
                        setSortActualScore('default');
                        setSortActualRating('default');
                        setSortScoreLatest('default');
                        setSortRatingLatest('default');
                        setSortScoreLatestMinusOne('default');
                        setSortRatingLatestMinusOne('default');
                    }}
                    variant="primary"
                    size="small"
                    children={"Reset Filters"}
                />
            </div>
            <div className="table-responsive" style={{overflowX: 'auto'}}>
                <table className="table calibration-table mt-3">
                    <thead>
                        <tr>
                            <th rowSpan={2} className="text-center">
                                {
                                    canCheckAll &&
                                    <Form.Check
                                        type={`checkbox`}
                                        onChange={(e) => {
                                            setMultipleJustificationDataByCheckbox(e, filteredUser)
                                        }}
                                        checked={checkAll}
                                        style={{ transform: 'scale(1.2)' }}
                                    />
                                }
                            </th>
                            <th rowSpan={2} className="text-center">No</th>
                            { 
                                filterColumn.includes('Employee') &&
                                <th rowSpan={2} className="text-center">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                        <span>Employee</span>
                                        <ExcelFilter
                                            options={userNameOption}
                                            selectedValues={filterUserName}
                                            onApply={(values) => {
                                                setFilterUserName(values);
                                            }}
                                            onSort={(direction) => {
                                                const nextState = direction === 'ascending' ? 'ascending' : 
                                                                 direction === 'descending' ? 'descending' : 'default';
                                                setSortName(nextState);
                                            }}
                                            currentSortState={sortName}
                                            placeholder="Filter"
                                            label="Employee"
                                        />
                                    </div>
                                </th>
                            }
                            { 
                                filterColumn.includes('Grade') &&
                                <th rowSpan={2} className="text-center">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                        <span>Grade</span>
                                        <ExcelFilter
                                            options={gradeOption}
                                            selectedValues={filterGrade}
                                            onApply={(values) => {
                                                setFilterGrade(values);
                                            }}
                                            onSort={(direction) => {
                                                const nextState = direction === 'ascending' ? 'ascending' : 
                                                                 direction === 'descending' ? 'descending' : 'default';
                                                setSortGrade(nextState);
                                            }}
                                            currentSortState={sortGrade}
                                            placeholder="Filter"
                                            label="Grade"
                                        />
                                    </div>
                                </th>
                            }
                            { 
                                filterColumn.includes('Supervisor') &&
                                <th rowSpan={2} className="text-center">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                        <span>Supervisor</span>
                                        <ExcelFilter
                                            options={supervisorNameOption}
                                            selectedValues={filterSupervisorName}
                                            onApply={(values) => {
                                                setSupervisorName(values);
                                            }}
                                            onSort={(direction) => {
                                                console.log('Sort supervisor:', direction);
                                            }}
                                            currentSortState="default"
                                            placeholder="Filter"
                                            label="Supervisor"
                                            showSort={false}
                                        />
                                    </div>
                                </th>
                            }
                            { 
                                filterColumn.includes('Division') &&
                                <th rowSpan={2} className="text-center">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                        <span>Division</span>
                                        <ExcelFilter
                                            options={divisionOption || []}
                                            selectedValues={filterDivision}
                                            onApply={(values) => {
                                                setFilterDivision(values);
                                            }}
                                            onSort={(direction) => {
                                                console.log('Sort division:', direction);
                                            }}
                                            currentSortState="default"
                                            placeholder="Filter"
                                            label="Division"
                                            showSort={false}
                                        />
                                    </div>
                                </th>
                            }
                            { 
                                filterColumn.includes('Prev. Rating') &&
                                <th rowSpan={2} className="text-center">  
                                    <div className="d-flex justify-content-center">
                                        Prev. Rating
                                    </div>
                                    <Select
                                        value={previousRating}
                                        options={options}
                                        onChange={(e) => setPreviousRating(e)}
                                        className="mt-2"
                                        style={{ width: "80px" }}
                                        placeholder="Select Rating"
                                        size="small"
                                    />         
                                </th>
                            }
                            { 
                                filterColumn.includes('Actual') &&
                                <th colSpan={2} className="text-center">Actual</th>
                            }
                            {
                                filterColumn.includes('Calibration (Previous)') &&
                                (
                                    projectPhase >=2 ?
                                    <th colSpan={2} className="text-center">
                                        <div className="d-flex justify-content-center">
                                            Calibration Phase
                                            <Select
                                                className="ms-1"
                                                defaultValue={-2}
                                                options={phaseOption}
                                                onChange={(e) => setLatestCalibration(e)}
                                            />
                                        </div>
                                    </th>:
                                    <></>
                                )
                            }
                            {
                                filterColumn.includes('Calibration') &&
                                (
                                    projectPhase ?
                                    <th colSpan={2} className="text-center">Calibration Phase {projectPhase}</th>:
                                    <></>
                                )
                            }
                            {
                                filterColumn.includes('Status') &&
                                <th rowSpan={2} className="text-center">Status</th>
                            }
                            {
                                filterColumn.includes('Justification') &&
                                <th rowSpan={2} className="text-center" style={{ minWidth: '100px' }}>Justification</th>
                            }
                            {
                                hasWaitingStatus &&
                                <th rowSpan={2} className="text-center">Action</th>
                            }
                        </tr>
                        <tr>
                            { 
                                filterColumn.includes('Actual') &&
                                <>            
                                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                            <span>Score</span>
                                            <ExcelFilter
                                                options={[]}
                                                selectedValues={[]}
                                                onApply={() => {}}
                                                onSort={(direction) => {
                                                    const nextState = direction === 'ascending' ? 'ascending' : 
                                                                     direction === 'descending' ? 'descending' : 'default';
                                                    setSortActualScore(nextState);
                                                }}
                                                currentSortState={sortActualScore}
                                                placeholder="Sort"
                                                label="Actual Score"
                                                showSort={true}
                                            />
                                        </div>
                                    </th>
                                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                            <span>Rating</span>
                                            <ExcelFilter
                                                options={ratingData}
                                                selectedValues={filterActualRating !== 'None' ? [filterActualRating] : []}
                                                onApply={(values) => {
                                                    setFilterActualRating(values.length > 0 ? values[0] : 'None');
                                                }}
                                                onSort={(direction) => {
                                                    const nextState = direction === 'ascending' ? 'ascending' : 
                                                                     direction === 'descending' ? 'descending' : 'default';
                                                    setSortActualRating(nextState);
                                                }}
                                                currentSortState={sortActualRating}
                                                placeholder="Filter"
                                                label="Actual Rating"
                                                singleSelect={true}
                                                showSort={true}
                                            />
                                        </div>
                                    </th>
                                </>
                            }
                            {
                                filterColumn.includes('Calibration (Previous)') &&
                                (
                                    projectPhase >= 2?
                                    <>
                                        <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                                <span>Score</span>
                                                <ExcelFilter
                                                    options={[]}
                                                    selectedValues={[]}
                                                    onApply={() => {}}
                                                    onSort={(direction) => {
                                                        const nextState = direction === 'ascending' ? 'ascending' : 
                                                                         direction === 'descending' ? 'descending' : 'default';
                                                        setSortScoreLatestMinusOne(nextState);
                                                    }}
                                                    currentSortState={sortScoreLatestMinusOne}
                                                    placeholder="Sort"
                                                    label="Previous Score"
                                                    showSort={true}
                                                />
                                            </div>
                                        </th>
                                        <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                                <span>Rating</span>
                                                <ExcelFilter
                                                    options={ratingData}
                                                    selectedValues={filterRatingBefore !== 'None' ? [filterRatingBefore] : []}
                                                    onApply={(values) => {
                                                        setFilterRatingBefore(values.length > 0 ? values[0] : 'None');
                                                    }}
                                                    onSort={(direction) => {
                                                        const nextState = direction === 'ascending' ? 'ascending' : 
                                                                         direction === 'descending' ? 'descending' : 'default';
                                                        setSortRatingLatestMinusOne(nextState);
                                                    }}
                                                    currentSortState={sortRatingLatestMinusOne}
                                                    placeholder="Filter"
                                                    label="Previous Rating"
                                                    singleSelect={true}
                                                    showSort={true}
                                                />
                                            </div>
                                        </th>
                                    </>:
                                    <></>
                                )
                            }
                            {
                                filterColumn.includes('Calibration') &&
                                <>
                                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                            <span>Score</span>
                                            <ExcelFilter
                                                options={[]}
                                                selectedValues={[]}
                                                onApply={() => {}}
                                                onSort={(direction) => {
                                                    const nextState = direction === 'ascending' ? 'ascending' : 
                                                                     direction === 'descending' ? 'descending' : 'default';
                                                    setSortScoreLatest(nextState);
                                                }}
                                                currentSortState={sortScoreLatest}
                                                placeholder="Sort"
                                                label="Calibration Score"
                                                showSort={true}
                                            />
                                        </div>
                                    </th>
                                    <th className="text-center" style={{ borderBottomColor: 'inherit' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                            <span>Rating</span>
                                            <ExcelFilter
                                                options={ratingData}
                                                selectedValues={filterRating !== 'None' ? [filterRating] : []}
                                                onApply={(values) => {
                                                    setFilterRating(values.length > 0 ? values[0] : 'None');
                                                }}
                                                onSort={(direction) => {
                                                    const nextState = direction === 'ascending' ? 'ascending' : 
                                                                     direction === 'descending' ? 'descending' : 'default';
                                                    setSortRatingLatest(nextState);
                                                }}
                                                currentSortState={sortRatingLatest}
                                                placeholder="Filter"
                                                label="Calibration Rating"
                                                singleSelect={true}
                                                showSort={true}
                                            />
                                        </div>
                                    </th>
                                </>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            filteredUser && filteredUser?.map((user, index) => (
                                <tr key={user.ID}>
                                    <td>
                                        {
                                            user.CalibrationScores[user.CalibrationScores.length - 1].Status === "Complete" && user.CalibrationScores[user.CalibrationScores.length - 1].SpmoStatus === "Waiting" && 
                                            <Form.Check
                                                type={`checkbox`}
                                                onChange={(e) => onChangeHandler(
                                                    e, 
                                                    user.CalibrationScores[user.CalibrationScores.length - 1].ProjectID, 
                                                    user.CalibrationScores[user.CalibrationScores.length - 1].EmployeeID,
                                                    user.CalibrationScores[user.CalibrationScores.length - 1].ProjectPhaseID,
                                                    user.CalibrationScores[user.CalibrationScores.length - 1].CalibratorID
                                                )}
                                                checked={checkBoxes[user.ID]}
                                                style={{ transform: 'scale(1.2)' }}
                                            />
                                        }
                                    </td>                      
                                    <td className="text-center">{index+1}</td>
                                    
                                    {
                                        filterColumn.includes('Employee') &&
                                        <td><b>{user.Name}</b> ({user.Nik})
                                            <br></br>{user.OrganizationUnit}
                                        </td>
                                    }
                                    {
                                        filterColumn.includes('Grade') &&
                                        <td className="text-center">{user.Grade}</td>
                                    }
                                    {
                                        filterColumn.includes('Supervisor') &&
                                        <td className="text-center">{user.SupervisorNames}</td>
                                    }
                                    {
                                        filterColumn.includes('Division') &&
                                        <td className="text-center">{user.Division || '-'}</td>
                                    }
                                    {
                                        filterColumn.includes('Prev. Rating') &&
                                        <td className="text-center">{user.ActualScores[0][previousRating+"Rating"]}</td>
                                    }
                                    {
                                        filterColumn.includes('Actual') &&
                                        <>
                                            <td 
                                                className="text-center" 
                                                data-tooltip-id="tooltip-actual-score"
                                                onMouseEnter={() => setDetailActualScore(user.ActualScores[0])}
                                            >
                                                {/* {
                                                    hasOneDigitAfterDecimal(user.ActualScores[0].ActualScore) ?
                                                    user.ActualScores[0].ActualScore.toFixed(2):
                                                    Math.trunc(user.ActualScores[0].ActualScore*100)/100
                                                } */}
                                                {
                                                    user.ActualScores[0].ActualScore
                                                }
                                            </td>
                                            <td className="text-center">{user.ActualScores[0].ActualRating}</td>
                                        </>
                                    }
                                    {
                                        filterColumn.includes('Calibration (Previous)') &&
                                        (
                                            user && user.CalibrationScores && user.CalibrationScores[user.CalibrationScores.length+latestCalibration] && user.CalibrationScores[user.CalibrationScores.length+latestCalibration] && projectPhase && projectPhase >=2 ?
                                            <>
                                                <td className="text-center">
                                                {/* {
                                                    hasOneDigitAfterDecimal(user.CalibrationScores[user.CalibrationScores.length+latestCalibration].CalibrationScore) ?
                                                    user.CalibrationScores[user.CalibrationScores.length+latestCalibration].CalibrationScore.toFixed(2):
                                                    Math.trunc(user.CalibrationScores[user.CalibrationScores.length+latestCalibration].CalibrationScore*100)/100
                                                }     */}
                                                {
                                                    user.CalibrationScores[user.CalibrationScores.length+latestCalibration].CalibrationScore
                                                }
                                                </td>
                                                <td className="text-center">{user.CalibrationScores[user.CalibrationScores.length+latestCalibration].CalibrationRating}</td>
                                            </>
                                            :<>
                                                {
                                                    projectPhase && projectPhase >=2 ?
                                                    <>          
                                                        <td className="text-center">-</td>
                                                        <td className="text-center">-</td>
                                                    </>:
                                                    <></>
                                                }
                                            </>

                                        )
                                    }
                                    {
                                        filterColumn.includes('Calibration') &&
                                        <>
                                            <td className="text-center">
                                                {
                                                    user && 
                                                    <>
                                                    {/* {
                                                        hasOneDigitAfterDecimal(user.CalibrationScores[user.CalibrationScores.length-1].CalibrationScore) ?
                                                        user.CalibrationScores[user.CalibrationScores.length-1].CalibrationScore.toFixed(2):
                                                        Math.trunc(user.CalibrationScores[user.CalibrationScores.length-1].CalibrationScore*100)/100
                                                    } */}
                                                    {
                                                        user.CalibrationScores[user.CalibrationScores.length-1].CalibrationScore
                                                    }
                                                    </>
                                                }
                                            </td>
                                            <td className="text-center">
                                                {user && user.CalibrationScores[user.CalibrationScores.length-1].CalibrationRating}
                                            </td>
                                        </> 
                                    }
                                    {
                                        filterColumn.includes('Status') &&
                                        <td className="text-center">
                                            <Tag 
                                                className="mb-2 mt-2"
                                                color={(user.CalibrationScores[user.CalibrationScores.length-1].SpmoStatus === 'Accepted' ? 'green' : user.CalibrationScores[user.CalibrationScores.length-1].SpmoStatus === 'Rejected' ? 'red' : user.CalibrationScores[user.CalibrationScores.length-1].SpmoStatus === 'Waiting' ? 'yellow' :'')} 
                                                key={user.ID+"spmo-status"}
                                                data-tooltip-id="tooltip-spmo-status"
                                                onMouseEnter={() => {
                                                    if (user.CalibrationScores[user.CalibrationScores.length-1].SpmoStatus === "Rejected") {
                                                        setSpmoComment(user.CalibrationScores[user.CalibrationScores.length-1].SpmoComment)
                                                    } else{
                                                        setSpmoComment()
                                                    }
                                                }}
                                            >
                                                {user.CalibrationScores[user.CalibrationScores.length-1].SpmoStatus}
                                            </Tag>
                                        </td>
                                    }
                                    {
                                        filterColumn.includes('Justification') &&
                                    <td className="text-end" style={{ verticalAlign: 'middle' }}>
                                            {/* Show warning icon only if user has AdditionalInfo */}
                                            {user.AdditionalInfo && (
                                                <button
                                                    className="me-2"
                                                    onClick={() => handleShowAdditionalInfoModal(user)}
                                                    title="View additional information"
                                                    style={{ 
                                                        background: 'none', 
                                                        border: 'none', 
                                                        padding: '0', 
                                                        cursor: 'pointer',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        verticalAlign: 'middle'
                                                    }}
                                                >
                                                    <AiOutlineWarning fontSize={16} color='#FF9F43' />
                                                </button>
                                            )}
                                            {(() => {
                                                let data = user.CalibrationScores.filter(obj => obj.ProjectPhaseID)

                                                if (
                                                    (data.length > 1 && data[data.length-2].JustificationType && data[data.length-2].JustificationType !== "default") 
                                                    || user.CalibrationScores[user.CalibrationScores.length-1].JustificationType !== "default" 
                                                    // || user.CalibrationScores[user.CalibrationScores.length-1].CalibrationRating === "A"
                                                    // || user.CalibrationScores[user.CalibrationScores.length-1].CalibrationRating === "A+"
                                                    || (user.CalibrationScores[user.CalibrationScores.length-1].JustificationType === "default" && user.CalibrationScores[user.CalibrationScores.length-1].Comment!=="")
                                                ) {
                                                    return <button 
                                                                className="transparent-button" 
                                                                onClick={() => {
                                                                    // setCalibrationJustification(user.CalibrationScores)
                                                                    setJustificationModalUserID(user.ID)
                                                                    setUserJustification({
                                                                            Nik: user.Nik,
                                                                            Name: user.Name,
                                                                            Designation: user.Position,
                                                                        })
                                                                    handleShowJustification()
                                                                }}
                                                                title="View justification"
                                                        >
                                                        <AiFillFolderOpen fontSize={16}/>
                                                    </button>  
                                                }
                                                return <></>
                                            })()} 
                                        </td>
                                    }
                                    {
                                        hasWaitingStatus &&
                                        <td className="text-center">
                                            {
                                                user.CalibrationScores[user.CalibrationScores.length-1].SpmoStatus === "Waiting" &&
                                            <>
                                                <Button type="primary" default className="mt-1 mb-1 me-1" 
                                                    onClick={() => {
                                                        setIsAcceptModal(true)
                                                        setUserApprove({
                                                            ProjectID: user.CalibrationScores[user.CalibrationScores.length-1].ProjectID,
                                                            EmployeeID: user.CalibrationScores[user.CalibrationScores.length-1].EmployeeID,
                                                            ProjectPhaseID: user.CalibrationScores[user.CalibrationScores.length-1].ProjectPhaseID,
                                                            CalibratorID: user.CalibrationScores[user.CalibrationScores.length-1].CalibratorID,
                                                        })
                                                        handleShow()
                                                    }}
                                                ><AiOutlineCheck/></Button>
                                                <Button type="primary" danger className="mt-1 mb-1 me-1"
                                                    onClick={() => {
                                                        setIsAcceptModal(false)
                                                        setUserApprove({
                                                            ProjectID: user.CalibrationScores[user.CalibrationScores.length-1].ProjectID,
                                                            EmployeeID: user.CalibrationScores[user.CalibrationScores.length-1].EmployeeID,
                                                            ProjectPhaseID: user.CalibrationScores[user.CalibrationScores.length-1].ProjectPhaseID,
                                                            CalibratorID: user.CalibrationScores[user.CalibrationScores.length-1].CalibratorID,
                                                        })
                                                        handleShow()
                                                    }}
                                                ><AiOutlineClose/></Button>
                                            </>
                                            }
                                        </td>
                                    }
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
                {userJustification && (
                    <JustificationModalLatest
                        show={showJustification}
                        handleClose={handleCloseJustification}
                        user={userJustification}
                        projectID={projectID}
                        calibratorID={calibratorID}
                        justificationModalUserID={justificationModalUserID}
                    />
                )}

                {/* Additional Info Modal */}
                {showAdditionalInfo && selectedAdditionalInfo && (
                    <div 
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 1050
                        }}
                        onClick={() => setShowAdditionalInfo(false)}
                    >
                        <div 
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '8px',
                                padding: '24px',
                                maxWidth: '600px',
                                width: '90%',
                                maxHeight: '80vh',
                                overflow: 'auto',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                                <AiOutlineWarning fontSize={24} color='#FF9F43' style={{ marginRight: '12px' }} />
                                <h5 style={{ margin: 0, fontWeight: '600' }}>Additional Information</h5>
                            </div>
                            
                            <div style={{ marginBottom: '16px', paddingBottom: '16px', borderBottom: '1px solid #e0e0e0' }}>
                                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                                    <strong>Name:</strong> {selectedAdditionalInfo.name}
                                </p>
                                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                                    <strong>NIK:</strong> {selectedAdditionalInfo.nik}
                                </p>
                                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                                    <strong>Position:</strong> {selectedAdditionalInfo.position || '-'}
                                </p>
                                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                                    <strong>Supervisor:</strong> {selectedAdditionalInfo.supervisor || '-'}
                                </p>
                            </div>
                            
                            <div style={{ 
                                backgroundColor: '#fff9f0', 
                                padding: '16px', 
                                borderRadius: '6px',
                                border: '1px solid #ffe0b2',
                                marginBottom: '16px'
                            }}>
                                <p style={{ 
                                    margin: 0, 
                                    fontSize: '14px', 
                                    lineHeight: '1.6',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    {selectedAdditionalInfo.info}
                                </p>
                            </div>
                            
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <ActionButtonGradient
                                    onClick={() => setShowAdditionalInfo(false)}
                                    variant='primary'
                                    children={"Close"}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <Tooltip
                    id="tooltip-spmo-status"
                    style={{ 
                        backgroundColor: "#efefef", 
                        color: "#222", 
                        width: "20rem"
                    }}
                >
                    <b>SPMO Status</b>
                    <hr/>
                    {
                        spmoComment &&
                        <>
                            SPMO Comment: <b>{spmoComment}</b>
                        </>
                    }
                    <div className="mb-1">
                        <Tag 
                            data-tooltip-id="tooltip-status"
                        >
                            -
                        </Tag>: Waiting from Calibrator to Submit the Calibrations
                    </div>
                    <div className="mb-1">
                        <Tag 
                            color={'yellow'}
                            data-tooltip-id="tooltip-status"
                        >
                            Waiting
                        </Tag>: Waiting SPMO approval
                    </div>
                    <div className="mb-1">
                        <Tag 
                            color={'red'}
                            data-tooltip-id="tooltip-status"
                        >
                            Rejected
                        </Tag>: Justification got rejected by SPMO
                    </div>
                    <div className="mb-1">
                        <Tag 
                            color={'green'}
                            data-tooltip-id="tooltip-status"
                        >
                            Accepted
                        </Tag>: Justification got accepted by SPMO
                    </div>
                </Tooltip>

                <Tooltip
                    // position="top"
                    id="tooltip-actual-score"
                    style={{ 
                        backgroundColor: "#efefef", 
                        color: "#222", 
                        width: "10rem"
                    }}
                >
                    <b>Score Detail</b>
                    <div className="mb-1">
                        PTT : {detailActualScore.PTTScore ? Math.trunc(detailActualScore.PTTScore*100)/100: <>N/A</>}
                    </div>
                    <div className="mb-1">
                        PAT : {detailActualScore.PATScore ? Math.trunc(detailActualScore.PATScore*100)/100 : <>N/A</>}
                    </div>
                    <div className="mb-1">
                        360 : {detailActualScore.Score360 ? Math.trunc(detailActualScore.Score360*100)/100: <>N/A</>}
                    </div>
                </Tooltip>
            </div>
        </div>
    )
}

export default CalibrationTableSpmo